// @core/api/endpoints/team/get_team_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamAvatarResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team avatar
 * Retrieves a specific avatar image by ID including its URL and metadata.
 */
export async function GetTeamAvatar(
  team_id: string,
  avatar_id: string,
  options?: RequestOptions
): Promise<GetTeamAvatarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/avatars/:avatar_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.get<GetTeamAvatarResponse>(requestPath, { ...requestOptions });
}
